(function () {
  'use strict';

  const KLAVIYO_API_KEY = 'XPTDUV';
  const KLAVIYO_BIS_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_API_KEY;

  customElements.get('product-notification') ||
    customElements.define(
      'product-notification',
      class extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector('[data-notification-form]');
          this.bisWrapper = this.querySelector('[data-klaviyo-bis-form]');
          this.emailInput = this.querySelector('[data-klaviyo-bis-email]');
          this.successMsg = this.querySelector('[data-klaviyo-success]');
          this.errorMsg = this.querySelector('[data-klaviyo-error]');
          this.popup = this.closest('dialog');
          this.popupClose = this.popup ? this.popup.querySelector('[data-popup-close]') : null;
        }

        connectedCallback() {
          this.form.addEventListener('submit', (e) => this.handleSubmit(e));
          if (this.popupClose) {
            this.popupClose.addEventListener('click', () => {
              this.resetForm();
            });
          }
        }

        async handleSubmit(e) {
          e.preventDefault();

          const email = this.emailInput.value.trim();
          const variantId = this.bisWrapper.dataset.variantId;

          if (!email || !variantId) return;

          const submitBtn = this.form.querySelector('[type="submit"]');
          submitBtn.disabled = true;
          submitBtn.querySelector('span').textContent = 'Submitting…';

          try {
            const response = await fetch(KLAVIYO_BIS_ENDPOINT, {
              method: 'POST',
              headers: {
  'content-type': 'application/json',
  revision: '2024-10-15',
},
              body: JSON.stringify({
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    channels: ['EMAIL'],
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email,
                        },
                      },
                    },
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: 'catalog-variant',
                        id: '$shopify:::$default:::' + variantId,
                      },
                    },
                  },
                },
              }),
            });

            if (response.ok) {
              this.showSuccess();
            } else {
              const err = await response.json();
              console.error('Klaviyo BIS error:', err);
              this.showError();
            }
          } catch (err) {
            console.error('Klaviyo BIS fetch error:', err);
            this.showError();
          }
        }

        showSuccess() {
          this.form.querySelector('.product__notification__form').style.display = 'none';
          this.successMsg.style.display = 'block';
          this.errorMsg.style.display = 'none';
        }

        showError() {
          const submitBtn = this.form.querySelector('[type="submit"]');
          submitBtn.disabled = false;
          submitBtn.querySelector('span').textContent = 'Notify Me';
          this.errorMsg.style.display = 'block';
        }

        resetForm() {
          this.form.reset();
          this.form.querySelector('.product__notification__form').style.display = '';
          this.successMsg.style.display = 'none';
          this.errorMsg.style.display = 'none';
          const submitBtn = this.form.querySelector('[type="submit"]');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.querySelector('span').textContent = 'Notify Me';
          }
        }
      }
    );
})();